import React from 'react'
import styled from 'styled-components'
import { SelectCP } from 'submodules/nerit-framework-ui/common/components/form-fields/select/SelectCP'
import { InputCP } from 'submodules/nerit-framework-ui/common/components/form-fields/input/InputCP'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { RowCP } from 'submodules/nerit-framework-ui/common/components/grid/row/RowCP'
import { ColumnCP } from 'submodules/nerit-framework-ui/common/components/grid/column/ColumnCP'
import { TextCP } from 'submodules/nerit-framework-ui/common/components/text/TextCP'
import { RegulationComparisonEnum } from 'submodules/nerit-aquatec-sdk/services/regulation/enums/RegulationComparisonEnum'
import { ConditionRowTP, RegulationConditionUtils } from 'modules/fields/utils/RegulationConditionUtils'
import { SelectReferenceFieldCP } from 'modules/fields/components/modals/modal-field-regulation/inner/SelectReferenceFieldCP'
import { ConditionalStateTP, FieldRegulationModalUtils, REQUIRED_FIELD_MESSAGE } from 'modules/fields/components/modals/modal-field-regulation/inner/FieldRegulationModalUtils'

interface ICPProps {
    state: ConditionalStateTP
    onChange: (state: ConditionalStateTP) => void
    fieldCode?: number
    showErrors: boolean
}

/**
 * Formatação condicional: parâmetro de referência e faixas (tipo de comparação, valor condicionante, limite).
 */
export function ConditionalLimitFormCP(props: ICPProps): JSX.Element {

    const isMissing = (value?: number): boolean => props.showErrors && (value === undefined || Number.isNaN(value))
    const errorOf = (missing: boolean): string | undefined => missing ? REQUIRED_FIELD_MESSAGE : undefined

    function updateRow(index: number, changes: Partial<ConditionRowTP>): void {
        props.onChange(FieldRegulationModalUtils.updateRow(props.state, index, changes))
    }

    return (
        <WrapperSCP>
            <SelectReferenceFieldCP
                value={props.state.referenceFieldCode}
                onChange={(referenceFieldCode) => props.onChange({ ...props.state, referenceFieldCode })}
                excludeFieldCode={props.fieldCode}
                errorMessage={errorOf(props.showErrors && !props.state.referenceFieldCode)}
            />

            <RowCP>
                <ColumnCP size={9}><TextCP text={'Tipo de comparação'} size={'small'} strong={true}/></ColumnCP>
                <ColumnCP size={8}><TextCP text={'Valor condicionante'} size={'small'} strong={true}/></ColumnCP>
                <ColumnCP size={5}><TextCP text={'Limite'} size={'small'} strong={true}/></ColumnCP>
            </RowCP>

            {
                props.state.rows.map((row, index) => {
                    const isBetween = RegulationConditionUtils.isBetween(row)
                    return (
                        <RowCP key={index}>
                            <ColumnCP size={9}>
                                <SelectCP
                                    options={RegulationConditionUtils.COMPARISON_OPTIONS}
                                    value={row.comparison}
                                    onChange={(comparison: RegulationComparisonEnum) => updateRow(index, { comparison })}
                                    errorMessage={errorOf(props.showErrors && !row.comparison)}
                                />
                            </ColumnCP>
                            <ColumnCP size={isBetween ? 4 : 8}>
                                <InputCP
                                    placeholder={isBetween ? 'De' : 'Valor'}
                                    value={RegulationConditionUtils.toInputText(row.value)}
                                    onChange={(value) => updateRow(index, { value: RegulationConditionUtils.parseNumber(value) })}
                                    errorMessage={errorOf(isMissing(row.value))}
                                />
                            </ColumnCP>
                            {
                                isBetween &&
                                <ColumnCP size={4}>
                                    <InputCP
                                        placeholder={'Até'}
                                        value={RegulationConditionUtils.toInputText(row.valueTo)}
                                        onChange={(valueTo) => updateRow(index, { valueTo: RegulationConditionUtils.parseNumber(valueTo) })}
                                        errorMessage={errorOf(isMissing(row.valueTo))}
                                    />
                                </ColumnCP>
                            }
                            <ColumnCP size={5}>
                                <InputCP
                                    placeholder={'Limite'}
                                    value={RegulationConditionUtils.toInputText(row.limit)}
                                    onChange={(limit) => updateRow(index, { limit: RegulationConditionUtils.parseNumber(limit) })}
                                    errorMessage={errorOf(isMissing(row.limit))}
                                />
                            </ColumnCP>
                            <ColumnCP size={2}>
                                <ButtonCP
                                    icon={'delete'}
                                    size={'small'}
                                    marginTop={8}
                                    tooltip={'Remover faixa'}
                                    onClick={() => props.onChange(FieldRegulationModalUtils.removeRow(props.state, index))}
                                />
                            </ColumnCP>
                        </RowCP>
                    )
                })
            }

            <ButtonCP
                type={'dashed'}
                marginTop={10}
                onClick={() => props.onChange(FieldRegulationModalUtils.addRow(props.state))}
            >
                Adicionar +
            </ButtonCP>
        </WrapperSCP>
    )
}

const WrapperSCP = styled.div`
    margin-top: 10px;

    .ant-btn-dashed {
        width: 100%;
    }
`
